import { ResultPage } from 'runtime/data/resultpage';
import { SearchResult } from 'runtime/data/searchresult';

export class SearchResultPage extends ResultPage<SearchResult> { }